import React from 'react';


function MyLoader(props){

  return(

    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      </div>
  )

}
  
  export default MyLoader;